import { DrilldownTypeSelect } from 'features/drilldown/components/fieldSelect'
import { useVersionAwareDrilldownPanelData } from 'features/drilldown/data/DrilldownPanelDataContext'
import { FC } from 'react'

import { CardsPanelData } from './CardsPanel'

export const CardsPanelConfigurationView: FC = () => {
  const { panelData, setPanelData } =
    useVersionAwareDrilldownPanelData<CardsPanelData>()
  const { selectedEntryType } = panelData

  return (
    <DrilldownTypeSelect
      label={<span style={{ fontSize: '12px' }}>Entry Type:</span>}
      selectedType={selectedEntryType}
      setSelectedType={(value) => {
        const newValue =
          typeof value === 'function' ? value(selectedEntryType) : value
        setPanelData((prev) => ({
          ...prev,
          selectedEntryType: newValue,
          currentPage: 1,
        }))
      }}
      placeholder='Select entry type'
      width='300px'
    />
  )
}
